/**
 * Ticketmaster (and the manual festival list) mark a called-off show status = 'cancelled'. A cancelled event is over
 * for the app's purposes: it files under Past in Groups and on your profile, never Upcoming/Going, and its page says
 * so (operator, 2026-09-23, Ocean Way Festival).
 */
export function isEventCancelled(event) {
  const status = String(event?.status ?? '').toLowerCase();
  return status === 'cancelled' || status === 'canceled';
}
